import React from "react";
import EntrepotFormContent from "./components/EntrepotFormContent";
import { EntrepotFormProvider } from "./context/EntrepotFormContext";

type Props = {
  onSubmit: (data: any) => Promise<any>;
  onReset: () => void;
  entrepot?: any;
  entrepotError?: any;
  defaultValuesForm?: any;
  isSubmitting?: boolean;
  parentCompanyId?: string;
};

const EntrepotForm: React.FC<Props> = ({
  onSubmit,
  onReset,
  entrepot,
  entrepotError,
  isSubmitting = false,
  defaultValuesForm = {},
  parentCompanyId,
}) => {
  return (
    <EntrepotFormProvider
      entrepot={entrepot}
      isSubmitting={isSubmitting}
      entrepotError={entrepotError}
      defaultValuesForm={defaultValuesForm}
      parentCompanyId={parentCompanyId}
    >
      <EntrepotFormContent onSubmit={onSubmit} onReset={onReset} />
    </EntrepotFormProvider>
  );
};

export default EntrepotForm;
